import { Placeholder, type Query } from "drizzle-orm";
import lodash from "lodash";
import { format } from "sql-formatter";

export const prettyPrintSQL = (query: Query): string =>
  format(query.sql, {
    params: [
      "", // Library is not smart enough to know Postgres 1-indexes its parameters
      ...query.params.map((p) => {
        if (p instanceof Placeholder) {
          // DBVisualizer's syntax for whitespace-tolerant named parameter markers
          // See: https://www.dbvis.com/docs/25.1/working-with-sql/parameterized-sql-variables-and-parameter-markers/using-parameter-markers/#named-parameter-markers
          return `:{${p.name}}`;
        }

        if (lodash.isString(p)) {
          return `'${p}'`;
        }

        return `'${p?.toString()}'` || "null";
      }),
    ],
    language: "postgresql",
    paramTypes: { numbered: ["$"] },
  });
